import React from 'react';

export const INPUT_DATA = [
  {
    name: "Required Fields",
    show_for_vote: true,
    items: [
      {
        type: 'textarea',
        name: 'name',
        label: 'SONA Name',
        instructions: "No special characters \".\", \"#\", \"$\"  [ ] can be used.  Up to 2 lines separated by \"\n\", 20 characters each",
        required: true
      },
      {
        type: 'select',
        name: 'type',
        label: "Type",
        required: true,
        options: [
          { value: "Connectivity", label: "Connectivity" },
          { value: "Consumer Goods", label: "Consumer Goods" },
          { value: "Apps", label: "Apps" },
          { value: "Education", label: "Education" },
          { value: "Entertainment", label: "Entertainment" },
          { value: "Financial/Insurance", label: "Financial/Insurance" },
          { value: "Food/Beverage", label: "Food/Beverage" },
          { value: "Music", label: "Music" },
          { value: "Travel", label: "Travel" },
          { value: "Vote", label: "Vote" },
          { value: "In-Store", label: "In-Store" },
          { value: "Others", label: "Others" }
        ]
      },
      {
        type: "file",
        name: "logo",
        label: "Logo",
        instructions: "Upload your face picture or logo. Size: 300 x300 px",
        changeHandler: 'image',
        labelCls: 'required'
      },
      {
        type: "textarea",
        name: "body",
        label: "Description",
        instructions: "Information about you, your business, product, or service",
        required: true,
        attrs: {
          rows: 5
        }
      },
      {
        type: "number",
        name: "phoneNum",
        label: "Phone",
        instructions: "Your phone: country + area code + number; only digits, no separators",
        required: true
      }
    ]
  },
  {
    name: "Optional Fields",
    show_for_vote: true,
    items: [
      {
        type: 'select',
        name: 'personal',
        label: "Personal",
        required: true,
        options: [
          { value: 'Yes', label: 'Yes'},
          { value: 'No', label: 'No'},
        ]
      },
      {
        type: "file",
        name: "User_clip",
        label: "Your audio clip",
        instructions: "Upload a 10-second clip from your favorite song in WAV format.",
        changeHandler: 'audio',
        inline_instructions: <span>You can use <a href="https://inettools.net/audio/cut-mp3-music-or-song-direct-online-free" target="_blank" rel="noopener noreferrer">this tool</a> to create a 10-second WAV file.</span>
      }
    ]
  },
  {
    name: "Social Links",
    items: [
      {
        type: "url",
        name: "facebook",
        label: "Facebook",
        instructions: "Link to Facebook"
      },

      {
        type: "url",
        name: "twitter",
        label: "Twitter",
        instructions: "Link to Twitter"
      },
      {
        type: "url",
        name: "instagram",
        label: "Instagram",
        instructions: "Link to Instagram"
      },
      {
        type: "url",
        name: "youtube",
        label: "YouTube",
        instructions: "Link to a YouTube item"
      },
      {
        type: "url",
        name: "google",
        label: "Google",
        instructions: "Link to Google"
      },
      {
        type: "url",
        name: "pinterest",
        label: "Pinterest",
        instructions: "Link to Pinterest"
      },
      {
        type: "url",
        name: "snapchat",
        label: "Snapchat",
        instructions: "Link to Snapchat"
      }
    ]
  },
  {
    name: "Websites",
    items: [
      {
        type: "url",
        name: "website",
        label: "Website 1",
        instructions: "Link to your first website",
      },
      {
        type: "url",
        name: "website2",
        label: "Website 2",
        instructions: "Link to your second website"
      },
      {
        type: "url",
        name: "website3",
        label: "Website 3",
        instructions: "Link to your third website"
      },
      {
        type: "text",
        name: "websitename",
        label: "Label for website 1",
        instructions: "Up to 8 letters",
      },
      {
        type: "text",
        name: "website2name",
        label: "Label for website 2",
        instructions: "Up to 8 letters"
      },
      {
        type: "text",
        name: "website3name",
        label: "Label for website 3",
        instructions: "Up to 8 letters"
      }
    ]
  },
  {
    name: "Images",
    items: [
      {
        type: "file",
        name: "extraImage",
        label: "Picture 1",
        changeHandler: 'image',
        instructions: "Upload image. Size: 300 x300 px"
      },
      {
        type: "file",
        name: "extraImage2",
        label: "Picture 2",
        changeHandler: 'image',
        instructions: "Upload image. Size: 300 x300 px"
      },

      {
        type: "file",
        name: "extraImage3",
        label: "Picture 3",
        changeHandler: 'image',
        instructions: "Upload image. Size: 300 x300 px"
      },

      {
        type: "text",
        name: "extraImagename",
        label: "Label for picture 1",
        instructions: "Up to 8 letters"
      },
      {
        type: "text",
        name: "extraImage2name",
        label: "Label for picture 2",
        instructions: "Up to 8 letters"
      },
      {
        type: "text",
        name: "extraImage3name",
        label: "Label for picture 3",
        instructions: "Up to 8 letters"
      }
    ]
  }
]

export const VOTE_INPUT_DATA = [
  {
    name: "Vote Options",
    items: [
      {
        type: "text",
        name: "option1",
        label: "Voting Choice 1",
        instructions: "Choice/Question – up to 20 characters",
        required: true
      },
      {
        type: "text",
        name: "option2",
        label: "Voting Choice 2",
        instructions: "Choice/Question – up to 20 characters",
        required: true
      },
      {
        type: "text",
        name: "option3",
        label: "Voting Choice 3",
        instructions: "Choice/Question – up to 20 characters"
      },
      {
        type: "text",
        name: "option4",
        label: "Voting Choice 4",
        instructions: "Choice/Question – up to 20 characters"
      },
      {
        type: "text",
        name: "option5",
        label: "Voting Choice 5",
        instructions: "Choice/Question – up to 20 characters"
      }
    ]
  }
]

export const INSTORE_INPUT_DATA = [
  {
    name: "Emergency Assistance",
    items: [
      {
        type: "textarea",
        name: "textScreen3",
        label: "Safety Guidance",
        instructions: "Provide safety guidance in case of emergency.",
        required: true
      },
      {
        type: "number",
        name: "inPhoneNum",
        label: "Phone for Help",
        instructions: "Your phone: country + area code + number; only digits, no separators. Local phone number to request emergency help or assistance",
        required: true
      }
    ]
  }
]

export const ADMIN_INPUT_DATA = [
  {
    name: "Admin Data",
    items: [
      {
        type: "text",
        name: "userId",
        label: "SONA OWNER",
        instructions: "Admin only field",
        admin: true,
        user_lookup: true
      },
      {
        type: "text",
        name: "textToShare",
        label: "textToShare",
        instructions: "Admin only field",
        admin: true
      },
      {
        type: "text",
        name: "coupon",
        label: "coupon",
        instructions: "Admin only field",
        admin: true
      },
      {
        type: "text",
        name: "personID",
        label: "ADDRESSEE",
        instructions: "Admin only field",
        admin: true,
        user_lookup: true
      },
      {
        type: "text",
        name: "premium",
        label: "premium",
        instructions: "Admin only field",
        admin: true
      },
      {
        type: "text",
        name: "sendEmail",
        label: "sendEmail",
        instructions: "Admin only field",
        admin: true
      },
      {
        type: "text",
        name: "showalldeals",
        label: "Show in Specials",
        instructions: "Admin only field",
        admin: true
      },
      {
        type: "text",
        name: "ownerCanManageMedia",
        label: "Owner Can Manage Media",
        instructions: "Admin only field ('Yes' or 'No')",
        admin: true
      },
      {
        type: "text",
        name: "code",
        label: "Code",
        instructions: "Admin only field",
        admin: true,
        locked: true
      },
      {
        type: "text",
        name: "uid",
        label: "Original Name (ID)",
        instructions: "Admin only field",
        admin: true,
        locked: true
      }
    ]
  }
]